import { AddressService } from './AddressService';
import { AuthenticationService } from './AuthenticationService';
import { DocumentReaderService } from './documentReader/DocumentReaderService';
import { MainService } from './main/MainService';
import { UploadService } from './UploadService';

export const authenticationService = new AuthenticationService();

export const addressService = new AddressService();

export const uploadService = new UploadService();

export const documentReaderService = new DocumentReaderService();

export const mainService = new MainService();
